require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.concat.js");
/* eslint-disable */
Array.prototype.insert = function (index) {
  if (isNaN(index)) throw new Error('please enter a number');
  for (var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    items[_key - 1] = arguments[_key];
  }
  this.splice.apply(this, [index, 0].concat(items));
};